import { useTranslation } from 'react-i18next';

import { Switch } from '@/components/ui/switch';

interface RecordContributionSaveOptionsProps {
  addAnother: boolean;
  onAddAnotherChange: (addAnother: boolean) => void;
  disabled?: boolean;
}

export const RecordContributionSaveOptions = ({
  addAnother,
  onAddAnotherChange,
  disabled = false,
}: RecordContributionSaveOptionsProps) => {
  const { t } = useTranslation('giving');

  return (
    <div className="space-y-3 rounded-lg border p-4">
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1">
          <p className="text-sm font-medium">{t('form.saveOptions.addAnother')}</p>
          <p className="text-xs text-fg-secondary">{t('form.saveOptions.addAnotherHint')}</p>
        </div>
        <Switch
          id="record-contribution-add-another"
          checked={addAnother}
          onCheckedChange={onAddAnotherChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};
